import {Facebook, Instagram, YouTube} from '@mui/icons-material'
import ic_aventura from "./Recursos/ic_aventura.svg";
import ic_mar from "./Recursos/ic_mar.svg";
import ic_tierra from "./Recursos/ic_tierra.svg";

export const SECCIONES = ['Tours', 'Nosotros']

export const REDES = [
    {
        icono: Instagram,
        url: 'https://www.instagram.com/overreceptour',
    },
    {
        icono: Facebook,
        url: 'https://www.facebook.com/OverReceptour',
    },
    {
        icono: YouTube,
        url: 'https://www.youtube.com/channel/UCjsoSH-EWetor87oP5hgulA?view_as=subscriber',
    },
]

export const CATEGORIAS = [
    {
        nombre: 'Aventura',
        icono: ic_aventura,
        numero: 10,
        descripcion: 'Eleva tus sentidos y descubre el mundo desde una perspectiva única con nuestros tours de aire. '
    },
    {
        nombre: 'Mar',
        icono: ic_mar,
        numero: 14,
        descripcion: 'Sumérgete en una experiencia inolvidable con nuestros tours de mar, diseñados para ofrecerte una conexión única con la belleza y la tranquilidad del océano. '
    },
    {
        nombre: 'Tierra',
        icono: ic_tierra,
        numero: 21,
        descripcion: 'Embárcate en una travesía fascinante por tierra con nuestros tours diseñados para ofrecerte una inmersión profunda en los paisajes, culturas y maravillas de la región. '
    },
]